app.service('SideBarService', function (ApiService, $rootScope) {

    this.RefreshHistory = function (objectId, lang, objectType, lastelementid) {
        //$rootScope.ShowIconLoading();
        var request = ApiService.get("/api/ChangeLogApi/GetChangeHistory?objectid=" + objectId + "&objectype=" + objectType + "&lang=" + lang + "&lastid=" + lastelementid)
        .then(
                function success(data) {
                    $rootScope.returnNewHistory = angular.copy(data.data);
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Update Description  status
    this.UpdateObjectStatus = function (status, objectId, lang, pageType, zoneId) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/UpdateObjectStatus?id=" + objectId + "&status=" + status + "&lang=" + lang + "&pageType=" + pageType+"&zoneId=" + zoneId)
        .then(
            function success(data) {
                $rootScope.ShowIconSuccess();                    

                if (status == 24 && pageType == $rootScope.EnumLinkType.Place) {
                    //console.log("Check max place number");
                    $rootScope.CurrentPlaceNumberOfZone = data.data.CurrentPlaceNumberOfZone;
                    $rootScope.MaxPlaceNumberOfZone = data.data.MaxPlaceNumberOfZone;

                    $rootScope.CheckMaxPlaceNumber($rootScope.CurrentPlaceNumberOfZone, $rootScope.MaxPlaceNumberOfZone);
                }
                else {
                    //console.log("Not check Max place number");
                }
            },
            function error(data) {
                $rootScope.ShowIconError();
            });
        return request;
    }

    //Update Description 
    this.AddComment = function (Comment, objectId, lang, pageType) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/AddComment?id=" + objectId + "&lang=" + lang + "&pageType=" + pageType, Comment)
        .then(
                function success(data) {                    
                    $rootScope.ShowIconSuccess();                    
                    $rootScope.returnNewComments = angular.copy(data.data);
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Update Description 
    this.SaveContact = function (Contact, objectId, lang, pageType) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SaveContact?id=" + objectId + "&lang=" + lang + "&pageType=" + pageType, Contact)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Save diffuseur
    this.SaveDiffuseur = function (Clients, objectId, lang, pageType) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SaveDiffuseur?id=" + objectId + "&lang=" + lang + "&pageType=" + pageType, Clients)
        .then(
                function success(data) {
                    console.log("SideBar service SaveDiffuseur");
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }


    //Save adresses
    this.SaveAdressesAssociees = function (Places, objectId, lang, pageType) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SaveAdressesAssociees?id=" + objectId + "&lang=" + lang + "&pageType=" + pageType, Places)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }       

    //Save adresses
    this.SaveClassification = function (Classification, objectId, lang, pageType) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SaveClassification?id=" + objectId + "&lang=" + lang + "&pageType=" + pageType, Classification)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Save SP
    this.SaveSP = function (SP, objectId, lang, pageType) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SaveSP?id=" + objectId + "&lang=" + lang + "&pageType=" + pageType,SP)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Save Place Geo
    this.SavePlaceGeo = function (DistrictList, objectId, lang, pageType) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SavePlaceGeo?id=" + objectId + "&lang=" + lang + "&pageType=" + pageType, DistrictList)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }


    //Save all kind of Place Field
    this.SavePlaceInfo = function (Place, objectId, lang, pageType) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SavePlaceInfo?id=" + objectId + "&lang=" + lang + "&pageType=" + pageType, Place)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }
    //Save contact (place) 
    this.SaveContactToObject = function (objectId, lang, pageType, ContactList) {
        var request = ApiService.post("/api/SideBar/SaveContactToObject?id=" + objectId + "&lang=" + lang + "&pageType=" + pageType, ContactList);
        return request;
    }

    //Send Verification Email (place) 
    this.SendOneVerificationEmail = function (objectId, pageType, ContactList) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SendOneVerificationEmail?id=" + objectId + "&pageType=" + pageType, ContactList)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Get LastSendingTimeOfVerificationEmailOfPlace
    this.GetLastSendingTimeOfVerificationEmailOfPlace = function (placeId) {
        var request = ApiService.get("/api/SideBar/GetLastSendingTimeOfVerificationEmailOfPlace?placeId=" + placeId);

        return request;
    }

    //Send All Place Verification Emails of one Zone 
    this.SendAllVerificationEmailOfOneZone = function (zoneId, pageType) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SendAllVerificationEmailOfOneZone?zoneId=" + zoneId + "&pageType=" + pageType)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }
    
    //Get LastSendingTimeOfVerificationEmailOfZone
    this.GetLastSendingTimeOfVerificationEmailOfZone = function (zoneId) {
        var request = ApiService.get("/api/SideBar/GetLastSendingTimeOfVerificationEmailOfZone?zoneId=" + zoneId);            

        return request;
    }    

    //Save all kind of iti Field
    this.SaveIti = function (iti, objectId, lang, pageType) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SaveIti?id=" + objectId + "&lang=" + lang + "&pageType=" + pageType, iti)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }


    //Save all kind of Place Field
    this.SaveAssEdito = function (BioList, objectId, lang, pageType) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SaveAssEdito?id=" + objectId + "&lang=" + lang + "&pageType=" + pageType, BioList)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Save associated places 
    this.SaveAssociatedPlaces = function (objectId, linkTypeId, lang, associatedPlaces) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SaveAssociatedPlaces?objectId=" + objectId + "&linkTypeId=" + linkTypeId + "&lang=" + lang, associatedPlaces)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Save associated Zones 
    this.SaveAssociatedZones = function (objectId, linkTypeId, lang, associatedZones) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SaveAssociatedZones?objectId=" + objectId + "&linkTypeId=" + linkTypeId + "&lang=" + lang, associatedZones)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Batch Modify Client for a list of object
    this.BatchModifyClient = function (topBarAction) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/BatchModifyClient", topBarAction)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Batch Modify Status for a list of object
    this.BatchModifyStatus = function (topBarAction) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/BatchModifyStatus", topBarAction)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Batch Replace Textfor a list of object
    this.BatchReplaceText = function (topBarAction) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/BatchReplaceText", topBarAction)
        .then(
                function success(data) {
                    $rootScope.BatchReplaceTextResult = data.data;
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }
});